import { formValueSelector } from 'redux-form';
import { AppState } from 'store';
import {
  PREACRIS_ONLINE_FORM,
  PreacrisFormPlaceholders,
  EMPTY_VALUE,
} from './Preacris.constants';

import { USStates, DriversResult, XDetailsResult } from './model';

type LocationsType = {
  name: string;
  hobCode: string;
}[];

type DocType = {
  docId: string;
  documentIdDescription: string;
}[];

export const usStateSelector = ({
  preacris: { usStates },
}: AppState): USStates => usStates;

const getPlaceHolder = (text: string) => [
  {
    value: EMPTY_VALUE,
    text,
  },
];

const getOptions = (locations: LocationsType) =>
  locations
    ? locations.map(({ name: text, hobCode: value }) => ({
        value,
        text: text === 'MT' ? 'MONTANA' : text, //`${text} ${value}`,
      }))
    : [];

const getDocumentOptions = (docs: DocType) =>
  docs
    ? docs.map(({ documentIdDescription: text, docId: value }) => ({
        value,
        text: text === 'MT' ? 'MONTANA' : text, //`${text} ${value}`,
      }))
    : [];

export const getStatesOptions = (usStates: USStates) => [
  ...getPlaceHolder(PreacrisFormPlaceholders.STATE),
  ...getOptions(usStates),
];

export const getCountyOptions = (usStates: USStates, stateHob: string) => {
  const placeHolder = getPlaceHolder(PreacrisFormPlaceholders.COUNTY);
  if (usStates?.length && stateHob) {
    const usstate = usStates.find(({ hobCode }) => hobCode === stateHob);
    return usstate?.counties?.length
      ? [...placeHolder, ...getOptions(usstate.counties)]
      : placeHolder;
  }
  return placeHolder;
};

export const getCounties = (usStates: USStates, stateHob: string) => {
  if (usStates?.length && stateHob) {
    const state = usStates.find(({ hobCode }) => hobCode === stateHob);
    return state ? state.counties : null;
  }
};

export const getCmt = (
  usStates: USStates,
  countyHob: string,
  stateHob: string,
  cmtdocId: string,
) => {
  if (usStates?.length && stateHob) {
    const state = usStates.find(({ hobCode }) => hobCode === stateHob);
    if (state?.counties?.length && countyHob) {
      const county = state.counties.find(
        ({ hobCode }) => hobCode === countyHob,
      );
      if (county?.cmts?.length && cmtdocId) {
        const cmt = county.cmts.find(({ docId }) => docId === cmtdocId);
        return cmt ? cmt : null;
      }
    }
  }
};

export const getFieldNames = (
  usStates: USStates,
  countyHob: string,
  stateHob: string,
  cmtdocId: string,
) => {
  if (usStates && usStates.length && stateHob) {
    const state = usStates.find(({ hobCode }) => hobCode === stateHob);
    if (state?.counties?.length && countyHob) {
      const county = state.counties.find(
        ({ hobCode }) => hobCode === countyHob,
      );
      if (county?.cmts?.length && cmtdocId) {
        const cmt = county.cmts.find(({ docId }) => docId === cmtdocId);
        if (cmt?.documentFieldNames?.length) {
          return cmt.documentFieldNames.split('|');
        }
      }
    }
  }
};

export const driversSelector = ({
  preacris: { driversData },
}: AppState): DriversResult => driversData;

export const xdetailsSelector = ({
  preacris: { xdetailsData },
}: AppState): XDetailsResult => xdetailsData;

export const getCmtOptions = (
  usStates: USStates,
  countyHob: string,
  stateHob: string,
) => {
  const placeHolder = getPlaceHolder(PreacrisFormPlaceholders.CMT);
  if (usStates?.length && stateHob) {
    const state = usStates.find(({ hobCode }) => hobCode === stateHob);
    if (state?.counties?.length && countyHob) {
      const county = state.counties.find(
        ({ hobCode }) => hobCode === countyHob,
      );
      return county?.cmts?.length
        ? [...placeHolder, ...getDocumentOptions(county.cmts)]
        : placeHolder;
    }
  }
  return placeHolder;
};

export const valueSelector = (state: AppState, fieldName: string) =>
  formValueSelector(PREACRIS_ONLINE_FORM)(state, fieldName);
